import createAxios from "./createAxios";
import addDays from "./addDays";
import formatDate from "./formatDate";

export interface IpoLockupResult {
    items: IpoLockup[]
    total: number
    page_size: number
}

export interface IpoLockup {
    symbol: string
    name: string
    ipo_type: string
    ipo_date: string
    initial_filling_date: string
    insider_lockup_date: string
    market_cap_at_offer: string
}

const api = createAxios()

export default async function fetchData({
                             type = 'upcoming',
                             timePeriod = '7',
                             marketCap = 'all',
                             sortingColumn,
                             sortingDirection,
                             page,
                             pageSize = 10,
                         }: any) {
    const today = new Date()
    const days = timePeriod ? Number(timePeriod) : 7

    const params: any = {
        page_size: pageSize,
    }

    if (page) {
        params.page = page
    }

    if (sortingColumn) {
        params.order_by = `${sortingColumn} ${sortingDirection ? sortingDirection.toLocaleLowerCase() : ''}`.trim()
    }

    if (type === 'historical') {
        params.insider_lockup_date__from = formatDate(addDays(today, days * -1))
        params.insider_lockup_date__to = formatDate(today)
    } else {
        params.insider_lockup_date__from = formatDate(today)
        params.insider_lockup_date__to = formatDate(addDays(today, days))
    }

    if (marketCap && marketCap !== 'all') {
        const [from, to] = marketCap.split('-')

        const addParamIfNumber = (key: string, value: string) => {
            const valueAsNumber = Number(value)

            if (isNaN(valueAsNumber) || valueAsNumber === 0) {
                return
            }

            params[key] = valueAsNumber
        }

        addParamIfNumber('market_cap_at_offer__from', from)
        addParamIfNumber('market_cap_at_offer__to', to)
    }

    return (await api.get<IpoLockupResult>('/ipo', { params })).data
}
